<template>
  <Modal title="Switch Client" @close="close" :hide-footer="true">
    <template #body>
      <div class="client-switch-container">
        <div class="client-switch" v-for="(client, c) in userLoginableItems" :key="c">
          <div>{{ client.name }}</div>
          <Btn
            variant="secondary"
            @click="
              () => {
                client.action();
                close();
              }
            "
            size="small"
          >
            Launch
          </Btn>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Btn from "@/components/display/Btn";
import { computed } from "vue";
import Modal from "@/components/display/Modal";
import store from "@/store";

export default {
  name: "SwitchClientModal",
  components: {
    Modal,
    Btn,
  },
  emits: ["close"],
  setup(props, { emit }) {
    const userLoginableItems = computed(() => store.getters["auth/getLoginableClientNavLinks"]);

    const close = () => emit("close");

    return {
      close,
      userLoginableItems,
    };
  },
};
</script>

<style lang="scss">
.client-switch {
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.5rem;
  border-bottom-width: 1px;
  border-bottom-style: solid;
}
</style>
